module.exports = {"532923101":"祥城镇","532923102":"沙龙镇","532923103":"云南驿镇","532923104":"下庄镇","532923105":"普棚镇","532923106":"刘厂镇","532923107":"禾甸镇","532923108":"米甸镇","532923201":"鹿鸣乡","532923202":"东山彝族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532923.json
// module id = 2650
// module chunks = 0